import { Sprite, Text } from 'pixi.js';

import { Shared } from '../App';
import { NineSliceButton } from './buttons/NineSliceButton';
import { Widget } from './Widget';

export class ConfirmationWidget extends Widget
{
    public yesButton: NineSliceButton;
    public noButton: NineSliceButton;
    public title: Text;

    constructor()
    {
        super();
        this.title = new Text('TITLE', {
            fontFamily: 'lubalin',
            fill: 0xFFFFFF,
            stroke: 0x333333,
            strokeThickness: 10,
            lineJoin: 'round',
            align: 'center',
            fontSize: 56,
        });
        this.title.anchor.set(0.5);
        this.view.addChild(this.title);
        this.title.y = -75;

        const yesIcon = Sprite.from(Shared.assets.getTexture('icon-tick'));

        this.yesButton = new NineSliceButton({
            icon: yesIcon,
            accessibleTitle: 'Yes',
            w: yesIcon.width * 1.5,
            h: yesIcon.height * 1.5,
        });
        this.view.addChild(this.yesButton.view);
        this.yesButton.view.x = -80;
        this.yesButton.view.y = -this.title.y;

        const noIcon = Sprite.from(Shared.assets.getTexture('icon-close'));

        this.noButton = new NineSliceButton({
            icon: noIcon,
            accessibleTitle: 'No',
            w: noIcon.width * 1.5,
            h: noIcon.height * 1.5,
        });
        this.view.addChild(this.noButton.view);
        this.noButton.view.x = -this.yesButton.view.x;
        this.noButton.view.y = this.yesButton.view.y;
    }
}
